
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transactions/sync-migration",
      function () {
        return require("private-next-pages/docs/transactions/sync-migration.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transactions/sync-migration"])
      });
    }
  